export interface ElectionBase {
  id: string;
  name: string;
  votingLink: string;
}

export const electionBaseFields = `
  id
  name
  votingLink
`;

export interface ElectionInput {
  congressId: string;
  name: string;
  votingLink: string;
}

export const electionInputFieldNames = [
  'congressId',
  'name',
  'votingLink',
] as const;
